import relativeDate from './relativeDate'

export { relativeDate }
